import myApi from '@/util/api'


export function getblisterLines(id) {
    console.log(id);
    return myApi.getByID(id, 'BlisterScrapLine/GetBlisterScrapLine')
}


// WEBPACK FOOTER //
// ./src/api/blisterScrapLine.js